/*
  CRAN. — Lecture des vidéos de hero (homepage + PDP), en aller-retour
  plutôt qu'en boucle brute. Un <video loop> saute d'un coup à la
  première image en fin de lecture — visible et pas franchement
  "quiet luxury". Ici : avant jusqu'à la fin, puis retour en arrière
  jusqu'au début, puis on relance en avant, indéfiniment — impression
  de mouvement continu, jamais de coupure nette.

  La lecture arrière est simulée en décrémentant currentTime image par
  image (les navigateurs ne supportent pas playbackRate négatif) : le
  pas est calculé sur le temps réel écoulé entre deux frames
  d'animation, pas sur un fps supposé, pour que l'aller-retour dure
  aussi longtemps dans un sens que dans l'autre quel que soit
  l'encodage de la vidéo source.

  Dégradé sûr, à deux niveaux :
  - prefers-reduced-motion actif → on ne touche à rien, la vidéo reste
    sur son image poster (identique à l'image statique remplacée).
  - JS qui ne tourne pas (bloqué, erreur) ou navigateur qui refuse
    l'autoplay → sans l'attribut loop natif, la vidéo lit une seule
    fois puis s'arrête sur sa dernière image. Dégradation raisonnable,
    pas de contenu cassé dans aucun cas.
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var videos = document.querySelectorAll('[data-cran-autoplay-video]');

  videos.forEach(function (video) {
    var lastTimestamp = null;
    var isReversing = false;

    function stepReverse(timestamp) {
      if (lastTimestamp === null) {
        lastTimestamp = timestamp;
      }
      var delta = (timestamp - lastTimestamp) / 1000;
      lastTimestamp = timestamp;

      if (video.currentTime <= delta) {
        video.currentTime = 0;
        lastTimestamp = null;
        isReversing = false;
        playForward();
        return;
      }

      video.currentTime -= delta;
      window.requestAnimationFrame(stepReverse);
    }

    function playForward() {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function startReverse() {
      // Garde contre un second 'ended' qui arriverait pendant qu'on est
      // déjà en train de rembobiner (observé sur certains moteurs après
      // un seek manuel) — sans elle, deux boucles de rembobinage peuvent
      // se chevaucher et donner l'impression que la vidéo "part à
      // l'envers" deux fois de suite au lieu d'alterner.
      if (isReversing) {
        return;
      }
      isReversing = true;
      // On force l'état pause natif avant de piloter currentTime à la
      // main : sinon le moteur vidéo peut tenter de reprendre la
      // lecture en avant pendant qu'on rembobine, et les deux se
      // battent sur currentTime.
      video.pause();
      lastTimestamp = null;
      window.requestAnimationFrame(stepReverse);
    }

    video.addEventListener('ended', startReverse);

    playForward();
  });
})();
